import { getIsCommercial } from '../../../../shared/utils/category/getIsCommercial';

export default [
  '$rootScope',
  'categoryService',
  'addFormService',
  'userService',
  'config',
  ($rootScope, categoryService, addFormService, userService, config) => {
    const homeownerInfo = (userService.user && userService.user.homeownerInfo) || {};

    let { userType, canPublishAsHomeowner } = homeownerInfo;

    // Если вдруг микросервис с новым типом собственник не отвечает, деградирую, и логика останется такая же, как и сейчас
    if (canPublishAsHomeowner === undefined) {
      canPublishAsHomeowner = window.addFormState.userCanPublishThisOfferAsHomeowner;
    }

    const isResidentialButNotNewbuilding = () => {
      const categoryInfo = categoryService.getInfoByCategory(addFormService.ad.category);

      return categoryInfo.propertyType === 'residential' && categoryInfo.objectType !== 'newBuildingFlat';
    };

    const service = {};

    service.isChangeToAgent = false;
    service.userCanPublishThisOfferAsHomeowner = !!canPublishAsHomeowner;
    service.userCanPublishThisOfferAsCommercialOwner = window.addFormState.userCanPublishThisOfferAsCommercialOwner;
    service.userType = userType === 'undefined' ? undefined : userType;
    service.userCanPublishAdAsHomeownerInCurrentCategory = () => {
      const isOfferIsExistingHomeowner = userType === 'homeowner' && addFormService.ad && addFormService.ad.id;

      return (
        (service.userCanPublishThisOfferAsHomeowner || isOfferIsExistingHomeowner) && isResidentialButNotNewbuilding()
      );
    };

    $rootScope.$watch(
      () => userService.user,
      () => {
        const newHomeownerInfo = (userService.user && userService.user.homeownerInfo) || {};
        const { userType: newUserType, canPublishAsHomeowner: newCanPublishAsHomeowner } = newHomeownerInfo;

        service.userCanPublishThisOfferAsHomeowner = !!newCanPublishAsHomeowner;
        service.userType = newUserType === 'undefined' ? undefined : newUserType;
        $rootScope.$broadcast('addForm.updateSegments');
      },
    );

    service.setUserCanPublishAsCommercialOwner = canPublishAsCommercialOwner => {
      if (service.userCanPublishThisOfferAsCommercialOwner != null) {
        service.userCanPublishThisOfferAsCommercialOwner = canPublishAsCommercialOwner;
      }
    };

    service.getHomeOwnerWarningVisibility = ({ isByHomeowner, isByCommercialOwner }) => {
      /**
       * @todo Удалить строку с фича-тогглом
       * @description Данный функционал появился в задаче CD-152528, будет удалён в задаче CD-152583
       */
      const commercialDisableAgentBanner = config.get('Commercial.DisableAgentBanner.Enabled');
      const { objectType } = categoryService.getInfoByCategory(addFormService.ad.category);

      // при включенном флаге "Соб коммерческой" проверяем дополнительные условия
      // при выключенном - стандартный флоу проверки жилой
      if (service.userCanPublishThisOfferAsCommercialOwner == null) {
        return (
          service.userType === 'homeowner' &&
          isByHomeowner === false &&
          /**
           * @todo Удалить условие с фича-тогглом и оставить только !getIsCommercial
           * @description Данный функционал появился в задаче CD-152528, будет удалён в задаче CD-152583
           */
          (commercialDisableAgentBanner
            ? !getIsCommercial(addFormService.ad.category) || objectType === 'garage'
            : true)
        );
      }

      // Для включенной функциональности "соб коммерческой" проверяем
      // не выбрал ли соб жилой хоть один из вариантов "собственник"
      // дополнительно проверяем может ли он вообще публиковаться как соб коммерческой
      const showWarningForHomeowner =
        service.userType === 'homeowner' &&
        isByHomeowner === false &&
        service.userCanPublishThisOfferAsCommercialOwner === true &&
        isByCommercialOwner === false &&
        /**
         * @todo Удалить условие с фича-тогглом и оставить только !getIsCommercial
         * @description Данный функционал появился в задаче CD-152528, будет удалён в задаче CD-152583
         */
        (commercialDisableAgentBanner ? !getIsCommercial(addFormService.ad.category) || objectType === 'garage' : true);

      // Для включенной функциональности "соб коммерческой" проверяем
      // не выбрал ли специалист хоть один из вариантов "собственник"
      // и дополнительно проверяем, может ли он вообще публиковаться как соб (жилой или коммерческой)
      const showWarningForSpecialist =
        service.userType === 'specialist' &&
        service.userCanPublishThisOfferAsCommercialOwner === true &&
        isByCommercialOwner === false &&
        service.userCanPublishThisOfferAsHomeowner === true &&
        isByHomeowner === false;

      return showWarningForHomeowner || showWarningForSpecialist;
    };

    return service;
  },
];
